export default __webpack_public_path__ + "static/media/mms.03737b94.avif";